import React from 'react'

const Trending = () => {
  return (
    <div>Trending</div>
  )
}

export default Trending